import type { InsuranceProviderSettingsGeneral } from '@/general/src/insuranceProvider/shared.js'
import { getConstKeys } from '@/general/src/other/getConstKeys.js'
import { z } from 'zod'

export const zAlfaSettings = z.object({
  login: z.string(),
  password: z.string(),
  manager: z.string(),
  signer: z.string(),
})
export type AlfaSettings = z.infer<typeof zAlfaSettings>
export const alfaSettingsInitialValues: AlfaSettings = {
  login: '',
  password: '',
  manager: '',
  signer: '',
}
export const alfaSettingsKeysMap = {
  login: 'Логин',
  password: 'Пароль',
  manager: 'Менеджер',
  signer: 'Подписаент',
}
export const alfaSettingsKeys = getConstKeys(alfaSettingsKeysMap)
export const alfaSettingsGeneral = {
  insuranceProvider: 'alfa',
  zSchema: zAlfaSettings,
  initialValues: alfaSettingsInitialValues,
  keysMap: alfaSettingsKeysMap,
  keys: alfaSettingsKeys,
} satisfies InsuranceProviderSettingsGeneral
